<template>
  <Fragment>
    <BaseButton :loading="isUploading" class="mx-0" @click="handleClick">
      <BaseIcon icon="cloud-arrow-up" tag="i" class="mr-2" />
      Upload
    </BaseButton>

    <input
      ref="inputRef"
      type="file"
      class="d-none"
      @change="handleFileUpload"
    />
  </Fragment>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'
import { Fragment } from 'vue-fragment'

import { useToast } from '@composables'
import { LincolnRLSGroupsService } from '@services'

import { BaseButton, BaseIcon } from '@components/base'
import { CompanyService } from '@services'

export default defineComponent({
  mname: 'CompanyRLSUploadButton',
  components: {
    Fragment,

    BaseButton,
    BaseIcon
  },
  emits: ['success'],
  setup(_, { emit }) {
    const { useGetters, useMutations } = createVuexHelpers()
    const { READ_COMPANY } = useMutations(['READ_COMPANY'])

    const { company } = useGetters(['company'])

    const { showToast } = useToast()

    const inputRef = ref(null)

    const handleClick = () => {
      if (!inputRef.value) return

      inputRef.value.click()
    }

    const isUploading = ref(false)

    const handleFileUpload = async (evt) => {
      isUploading.value = true

      try {
        const { files } = evt.target || {}

        const formData = new FormData()
        const companyId = company.value.id;

        formData.append('rls_group_file', files[0])

        const res = await LincolnRLSGroupsService.upload(
          companyId,
          formData
        )
        let companyRes = await CompanyService.read(companyId);
        const companyData = companyRes.data && companyRes.data.data || {};
        READ_COMPANY(companyData);

        isUploading.value = false

        showToast('RLS group file uploaded successfully.')

        emit('success')
      } catch (e) {
        const { response } = e || {}

        isUploading.value = false

        if (!!response) {
          const { data } = response || {}
          const { data: error } = data || {}

          showToast(error.message, 'error')
        } else {
          showToast('File is not a zip file.', 'error')
        }

      } finally {
        inputRef.value.value = '';
      }
    }

    return {
      inputRef,

      handleClick,

      isUploading,
      handleFileUpload
    }
  }
})
</script>
